//removing the + icon and extra line between the first and second scroller elements when the second scroller element doesn't exist
window.Drupal.behaviors.benefitsScroller = {
    attach: function (context) {
        const benefitsScroller = context.querySelector('.benefits-scroller');
        if (benefitsScroller == null) return;
        const benefitsScrollerGrid = benefitsScroller.querySelectorAll('.benefits-scroller__grid');
        if (benefitsScrollerGrid.length < 2) {
            const secondBenefitScrollerGridColumn = benefitsScrollerGrid[0].querySelector(
                '.benefits-scroller__column:nth-child(2)'
            );
            secondBenefitScrollerGridColumn.querySelector('.benefits-scroller__plus').remove();
            secondBenefitScrollerGridColumn.querySelector('.benefits-scroller__line').remove();
        }
    },
};
